import {Breakpoints} from '@volkswagen-onehub/components-core'
import {css} from 'styled-components'

export enum gridUtils {
    gapHalf = '15px',
    gap = '30px',
    gapDouble = '60px',
}

export const boxedContainer = css`
    --padding-x: 20px;

    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;

    @media (min-width: ${Breakpoints.b560}px) {
        padding-right: var(--padding-x);
        padding-left: var(--padding-x);
    }

    @media (min-width: ${Breakpoints.b1280}px) {
        --padding-x: 0;
    }
`
